export default __webpack_public_path__ + "static/media/Pig-Game.90208e54.png";